/**
 * Southern Tool Steel copy for the "What Our Customers Say" testimonial carousel in
 * `./WhatOurCustomersRefactor.tsx`. The STS build is dormant: kept until `web-cms-consumer` takes
 * over the STS marketing site, with nothing new built on it.
 */
import { WhatOurCustomersSayContent } from "./WhatOurCustomersRefactor";
import { LanguageContent } from "@components/Shared/model/LanguageContent";

/**
 * Southern Tool Steel testimonials: three customer quotes that share one YouTube video and its
 * thumbnail. `./WhatOurCustomersRefactor.tsx` → `WhatOurCustomers` uses it when
 * `NEXT_PUBLIC_COMPANY` is `southernToolSteel`. The `fr` and `es` quotes repeat the English text;
 * only `title` and `navLabel` are translated.
 */
export const STSWhatOurContentSays: LanguageContent<WhatOurCustomersSayContent> = {
	en: {
		title: "What Our Customers Say",
		navLabel: "Testimonials",
		videoId: "Nn1DJ3TS3DE",
		thumbnailUrl: "/images/sts/home-page/STSWhatOurCustomersSay.jpg",
		slides: [
			{
				person: "Keith",
				personLabel: "Alabama Machine Works",
				quote: `From sales to delivery, everyone at Southern Tool Steel always does a great job for us.`,
			},
			{
				person: "Jeremy",
				personLabel: "Dienamic Tooling Systems, Inc.",
				quote: `Our Southern Tool Steel rep does a great job of accommodating our needs and help in any way possible.`,
			},
			{
				person: "Tanya",
				personLabel: "Skyline Manufacturing",
				quote: `We love working with Southern Tool Steel, their reps are always very helpful and informative on our projects.`,
			},
		],
	},
	fr: {
		title: "Témoignages de nos clients",
		navLabel: "Témoignages",
		videoId: "Nn1DJ3TS3DE",
		thumbnailUrl: "/images/sts/home-page/STSWhatOurCustomersSay.jpg",
		slides: [
			{
				person: "Keith",
				personLabel: "Alabama Machine Works",
				quote: `From sales to delivery, everyone at Southern Tool Steel always does a great job for us.`,
			},
			{
				person: "Jeremy",
				personLabel: "Dienamic Tooling Systems, Inc.",
				quote: `Our Southern Tool Steel rep does a great job of accommodating our needs and help in any way possible.`,
			},
			{
				person: "Tanya",
				personLabel: "Skyline Manufacturing",
				quote: `We love working with Southern Tool Steel, their reps are always very helpful and informative on our projects.`,
			},
		],
	},
	es: {
		title: "Lo que dicen nuestros clientes",
		navLabel: "Testimonios",
		videoId: "Nn1DJ3TS3DE",
		thumbnailUrl: "/images/sts/home-page/STSWhatOurCustomersSay.jpg",
		slides: [
			{
				person: "Keith",
				personLabel: "Alabama Machine Works",
				quote: `From sales to delivery, everyone at Southern Tool Steel always does a great job for us.`,
			},
			{
				person: "Jeremy",
				personLabel: "Dienamic Tooling Systems, Inc.",
				quote: `Our Southern Tool Steel rep does a great job of accommodating our needs and help in any way possible.`,
			},
			{
				person: "Tanya",
				personLabel: "Skyline Manufacturing",
				quote: `We love working with Southern Tool Steel, their reps are always very helpful and informative on our projects.`,
			},
		],
	},
};

/**
 * The same object under the Ryerson module's export name (`./RefactorContent.tsx` →
 * `WhatOurContentSays`). The STS-only pages under
 * `pages/metal-solutions/{services,industries-served,solutions}/` import this name for the
 * testimonial section's title in their `AllSections` list.
 */
export const WhatOurContentSays = STSWhatOurContentSays;
